import { MarketingApiService, UpdateSubscriptionRequest } from 'src/api';
import { injectable } from 'inversify';
import { FieldState, FormState } from 'formstate';
import { computed, observable } from 'mobx';

@injectable()
export class SubscriptionStore {
    constructor(private marketingApi: MarketingApiService) {
        this.optionsForm.validators(
            () => !this.isAnySelected && 'Please select at least one option'
        );
    }

    async updatePreferences(emailId: string) {
        this.optionsForm.validate();

        const options = this.optionsForm.$;
        const request: UpdateSubscriptionRequest = {
            emailId,
            agingEquipment: options.agingEquipment.value,
            expiringMemberships: options.expiringMemberships.value,
            idleAccount: options.idleAccount.value,
            unsoldEstimates: options.unsoldEstimates.value,
            other: options.other.value,
            recurringService: options.recurringService.value,
            newsletter: options.newsletter.value,
            thankYou: options.thankYou.value,
            customerWelcome: options.customerWelcome.value,
        };

        if (this.isAnySelected) {
            await this.marketingApi.updateSubscription(request);

            this.submitted = true;
            this.unsubscribed = false;
        }
    }

    @computed
    get isAnySelected() {
        return this.optionsFormList.some((f) => f.value);
    }

    async unsubscribe(emailId: string) {
        await this.marketingApi.unsubscribe(emailId);
        this.unsubscribed = true;
        this.submitted = false;
    }

    @observable submitted = false;
    @observable unsubscribed = false;

    optionsForm = new FormState({
        unsoldEstimates: new FieldState(false),
        agingEquipment: new FieldState(false),
        expiringMemberships: new FieldState(false),
        idleAccount: new FieldState(false),
        other: new FieldState(false),
        recurringService: new FieldState(false),
        newsletter: new FieldState(false),
        thankYou: new FieldState(false),
        customerWelcome: new FieldState(false),
    });

    private optionsFormList = [
        this.optionsForm.$.idleAccount,
        this.optionsForm.$.expiringMemberships,
        this.optionsForm.$.agingEquipment,
        this.optionsForm.$.unsoldEstimates,
        this.optionsForm.$.other,
        this.optionsForm.$.recurringService,
        this.optionsForm.$.newsletter,
        this.optionsForm.$.thankYou,
        this.optionsForm.$.customerWelcome,
    ];
}
